import type { UseMutationOptions } from 'react-query';
import { useMutation } from '@frontend/react-query-helpers';
import {
  detachPaymentMethod,
  type DetachPaymentMethodProps,
  type DetachPaymentMethodResponse,
} from '../requests/detach-payment-method';
import { paymentMethodMutationKeys } from './keys';

export const useDetachPaymentMethod = (
  options?: UseMutationOptions<DetachPaymentMethodResponse, unknown, DetachPaymentMethodProps>
) => {
  return useMutation({
    mutationKey: paymentMethodMutationKeys.detachPaymentMethod,
    mutationFn: (request) => detachPaymentMethod(request),
    ...options,
  });
};
